import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';

class RouteWatcher extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location &&
      prevProps.location &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      this.onRouteChange();
    }
  }

  componentDidMount() {
    // apply smooth scroll polyfill
    smoothscroll.polyfill();
  }

  onRouteChange = () => {
    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    });
  };

  render() {
    const { children } = this.props;
    return children ? children : null;
  }
}

export default withRouter(RouteWatcher);
